export function labelText(label, fallback = '') {
  if (!label) return fallback
  if (typeof label === 'string') return label

  const locale = localStorage.getItem('locale') || 'en_US'
  if (label[locale]) return label[locale]
  if (label.en_US) return label.en_US
  if (label.locales && label.locales[locale]) return label.locales[locale]
  if (label.locales && label.locales.en_US) return label.locales.en_US

  const first = Object.keys(label)[0]
  return first ? label[first] : fallback
}

export function statusVariant(status) {
  if (status === 'published') return 'success'
  if (status === 'disabled') return 'danger'
  return 'secondary'
}

export function healthVariant(status) {
  if (status === 'healthy') return 'success'
  if (status === 'unhealthy') return 'danger'
  return 'secondary'
}

export function shortHash(hash) {
  if (!hash) return '-'
  return hash.length > 22 ? `${hash.slice(0, 19)}...` : hash
}

export function defaultSchema() {
  return {
    schema_version: '2026-06-24.my-satellite.v1',
    schema: {
      name: 'my-satellite',
      description: 'Satellite schema for JSON-RPC command and workflow node execution.'
    },
    permissions: [
      {
        action: 'execute',
        label: { en_US: 'Execute satellite commands' },
        description: { en_US: 'Allows running JSON-RPC commands exposed by the satellite.' }
      },
      {
        action: 'read_resource',
        label: { en_US: 'Resolve satellite resources' },
        description: { en_US: 'Allows resolving PRNs owned by the satellite.' }
      }
    ],
    jsonrpc_commands: [
      { name: 'echo', method: 'echo', permission_action: 'execute' },
      { name: 'uppercase', method: 'workflow.uppercase', permission_action: 'execute' },
      { name: 'resolve_resource', method: 'resource.resolve', permission_action: 'read_resource' }
    ],
    workflownodes: [
      {
        name: 'satellite.my-satellite.uppercase',
        label: { en_US: 'Uppercase Text' },
        description: { en_US: 'Converts input text to uppercase using the satellite.' },
        icon: 'type',
        command: 'uppercase',
        inputs: [
          {
            name: 'text',
            type: 'string',
            required: true,
            label: { en_US: 'Text' },
            description: { en_US: 'Text to transform.' }
          }
        ],
        outputs: [
          { name: 'text', type: 'string' },
          { name: 'uppercase', type: 'string' },
          { name: 'length', type: 'number' }
        ]
      }
    ]
  }
}
